module.exports = __webpack_public_path__ + "img/galery19.c69ffcdb.jpg";